import PropTypes from "prop-types";
import React from "react";
import { Alert, Box, Loader, Text } from "@mantine/core";
import { useStylesFileManager } from "../utils/mantine/useStylesFileManager";
import { IconMessageReportFilled } from "@tabler/icons-react";

const FileFoundPreview = ({
  preview,
  filePreviewError,
  loadingFilePreview,
  fileType,
}) => {
  const { classes: classesFileManager } = useStylesFileManager();

  return (
    <Box className="file-found-preview-container">
      {loadingFilePreview && (
        <Loader className={classesFileManager.linkLoader} />
      )}

      <Box className="file-found-preview">
        {filePreviewError && (
          <Alert
            variant="transparent"
            className={`${classesFileManager.alert} ${classesFileManager.alertFile}`}
            title={filePreviewError}
            icon={<IconMessageReportFilled />}
          ></Alert>
        )}

        {(fileType === "text" || fileType === "csv") && preview && (
          <>
            <Text className="file-found-preview-title">File Preview</Text>
            <Text className="file-found-preview-text" component="pre">
              {preview}
            </Text>
          </>
        )}

        {fileType === "image" && preview && (
          <>
            <Text className="file-found-preview-title">Image Preview</Text>
            <Box className="file-found-preview-img">
              <img src={preview} alt="Image Preview" />
            </Box>
          </>
        )}

        {fileType === "pdf" && preview && (
          <>
            <Text className="file-found-preview-title">PDF Preview</Text>
            <Box className="file-found-preview-img">
              <img src={preview} alt="PDF Preview" />
            </Box>
          </>
        )}

        {fileType === "html" && preview && (
          <>
            <Text className="file-found-preview-title">Content Preview</Text>
            <Box
              className="file-found-preview-text"
              dangerouslySetInnerHTML={{ __html: preview }}
            ></Box>
          </>
        )}
      </Box>
    </Box>
  );
};
FileFoundPreview.propTypes = {
  preview: PropTypes.string,
  filePreviewError: PropTypes.string,
  loadingFilePreview: PropTypes.bool,
  fileType: PropTypes.string,
};
export default FileFoundPreview;
